const swiperDTC = new Swiper('.as-seen-on-slider', {
  // Optional parameters
  direction: 'horizontal',
  slidesPerView: 1,
  loop: false,
  spaceBetween: 100,
  centeredSlides: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  breakpoints: {
    989: {
      direction: 'horizontal',
      slidesPerView: 5,
      loop:false,
      spaceBetween: 24,
      centeredSlides: false, 
    }
  }
});